import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { StatieItems } from "../../components";
import { useEffect, useState, type SetStateAction } from "react";
import { useMarketPricing } from "../../store/useMarketPricing";
import { VolumesGeneralFilters } from "./VolumesGeneralFilters";
import { Materials } from "../../components/charts/Materials.chart";
import { MaterialVolumesPerStore } from "../../components/charts/MaterialVolumesPerMaterial.chart";
import { ParcelVolumesPerCourier } from "../../components/charts/ParcelVolumesPerCourier.chart";
import { ParcelItems } from "../../components/charts/ParcelItems.chart";

function VolumesScreenMain() {
  const { getAllMarketPrices } = useMarketPricing();
  const [filterType, setFilterType] = useState<"location" | "city">("location");
  const [filterPlaces, setFilterPlaces] = useState<string[]>([]);
  const [sequenceStep, setSequenceStep] = useState(0);

  /** Effects */
  useEffect(() => {
    getAllMarketPrices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** When general filter changes, run chart fetches in sequence (step 0 → 1 → …) */
  useEffect(() => {
    setSequenceStep(0);
  }, [filterType, filterPlaces]);

  /** Reset sequence synchronously when user changes filter type so charts see step=0 on first render */
  const setFilterTypeWithReset = (v: SetStateAction<"location" | "city">) => {
    setSequenceStep(0);
    setFilterType(v);
  };

  return (
    <main>
      <VolumesGeneralFilters
        filterType={filterType}
        setFilterType={setFilterTypeWithReset}
        filterPlaces={filterPlaces}
        setFilterPlaces={setFilterPlaces}
      />
      <Materials
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={0}
      />
      <MaterialVolumesPerStore
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={1}
      />
      <StatieItems
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={2}
      />
      <ParcelVolumesPerCourier
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={3}
      />
      <ParcelItems
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={4}
      />
    </main>
  );
}

export default withProtectedRoute(VolumesScreenMain);
